<template>
  <el-table-column ref="ElTableColumnDict" v-on="$listeners" v-bind="$attrs">
    <template
      v-for="(slot, key) in $scopedSlots"
      :slot="key"
      slot-scope="scope"
    >
      <slot :name="key" v-bind="scope"></slot>
    </template>
    <template v-for="(slot, key) in $slots" :slot="key">
      <slot :name="key"></slot>
    </template>
    <template slot-scope="scope">
      <template v-if="dictType">
        {{
          GetLabelByCodesFilter(scope.row[$attrs.prop], dictType, dictOptions)
        }}
      </template>
      <template v-else-if="dictTreeType">
        {{
          GetTreeLabelByCodesFilter(
            scope.row[$attrs.prop],
            dictTreeType,
            dictTreeOptions
          )
        }}
      </template>
      <template v-else-if="dateFormat">
        {{ FormatDate(scope.row[$attrs.prop], dateFormat, defaultVal) }}
      </template>
      <template v-else-if="maskType || maskStart">
        {{ Desensitization(scope.row[$attrs.prop], maskOptions) }}
      </template>
      <template v-else>
        {{ scope.row[$attrs.prop] || defaultVal }}
      </template>
    </template>
  </el-table-column>
</template>
<script>
import { GetLabelByCodesFilter } from "~/filters/dict.js"
import { GetTreeLabelByCodesFilter } from "~/filters/tree-dict.js"
import { FormatDate } from "~/functions/date-format.js"
import { Desensitization } from "~/functions/mask.js"
export default {
  name: "el-table-column-dict",
  props: {
    // 字典类型
    dictType: {
      type: String,
      default: ""
    },
    dictTreeType: {
      type: String,
      default: ""
    },
    // 日期格式化
    dateFormat: {
      type: String
    },
    //缺省时展示
    defaultVal: {
      type: String,
      default: ""
    },
    // 格式化展示内容
    formatFun: {
      type: Function,
      default: null
    },
    // 格式化展示内容
    formatFunIn: {
      type: Function,
      default: null
    },
    // 格式化展示内容
    formatFunOut: {
      type: Function,
      default: null
    },
    // 间隔符
    spacer: {
      type: String,
      default: ","
    },

    treeSetting: {
      type: Object,
      default: null
    },

    // 脱敏类型
    maskType: {
      type: String,
      validate(value) {
        return ["mobile", "address", "idCard", "name"].includes(value)
      }
    },
    maskStart: {
      type: Number
    },
    maskEnd: {
      type: Number
    },
    maskMiddle: {
      type: Number
    },
    maskSymbol: {
      type: String,
      default: "*"
    }
  },
  data() {
    return {
      GetLabelByCodesFilter,
      GetTreeLabelByCodesFilter,
      FormatDate,
      Desensitization
    }
  },
  computed: {
    dictOptions() {
      const obj = {}
      if (this.defaultVal) {
        obj.defaultVal = this.defaultVal
      }
      if (this.formatFun) {
        obj.formatFun = this.formatFun
      }
      if (this.spacer) {
        obj.spacer = this.spacer
      }
      return obj
    },

    dictTreeOptions() {
      const obj = {}
      if (this.defaultVal) {
        obj.defaultVal = this.defaultVal
      }
      if (this.formatFunIn) {
        obj.formatFunIn = this.formatFunIn
      }
      if (this.formatFunOut) {
        obj.formatFunOut = this.formatFunOut
      }
      if (this.treeSetting) {
        obj.treeSetting = this.treeSetting
      }
      if (this.spacer) {
        obj.spacer = this.spacer
      }
      return obj
    },
    maskOptions() {
      const obj = {}
      if (this.defaultVal) {
        obj.defaultVal = this.defaultVal
      }
      if (this.maskType) {
        obj.maskType = this.maskType
      }
      if (this.maskStart) {
        obj.start = this.maskStart
      }
      if (this.maskEnd) {
        obj.end = this.maskEnd
      }
      if (this.maskMiddle) {
        obj.middle = this.maskMiddle
      }
      if (this.maskSymbol) {
        obj.symbol = this.maskSymbol
      }
      return obj
    }
  },
  methods: {
    getRef() {
      return this.$refs.ElTableColumnDict
    }
  }
}
</script>
